import React from "react";
import "./Projects.css";
import githubIcon from "../../images/githubIcon.png";
import pdfIcon from "../../images/pdfIcon.png";

const projects = [
    {
        type: "Bachelor's Project",
        title: "Exploring DETR for Recognition and Detection of Traffic Signs",
        description: "This project is focused on machine vision detecting traffic signs to aid self-driving cars. We explore the viability of the DETR algorithm to perform real-time traffic sign detection. Our findings indicate that, while DETR is able to perform real-time detection, it is not comparable to other state-of-the-art models like YOLO and R-CNN.",
        technologies: ["Python", "PyTorch"],
        github:"https://github.com/Traffic-sign-detection-P6AAU",
        paper: "/Bachelor_project.pdf"
    },
    {
        type: "[ONGOING] Master's Thesis",
        title: "AR Video Placement During Cardio Exercise",
        description: "When exercising, especially during indoor machine cardio, many make exercising more enjoyable by watching TV shows or other forms of visual content. However, the current viewing experience is poor, as people use their phone with a small screen. In our research, we investigate the use of Augmented Reality to achieve the best viewing experience for cardio exercise, by dynamically adjusting screen size based on exercise intensity.",
        technologies: ["C#", "Unity", "Python"],
        github:"https://github.com/Kristoffermg/ARVid",
    },
    {
        type: "Personal Project",
        title: "A Personal Portfolio Website",
        description: "A website I made for myself to show others what skills i have, as well as what oher projects i have been a part of.",
        technologies: ["JavaScript", "React", "HTML", "CSS"],
        github:"https://github.com/Schwartz123/portfolio",
    },
    {
        type: "Semester Project",
        title: "TRACE-Q: Trajectory Reduction using Accuracy Control for Reliable Querying",
        description: "8th semester project, focused on trajectory simplification while maintaining high queryability.",
        technologies: ["C++"],
        github:"https://github.com/KarmaKamikaze/TRACE-Q",
        paper: "/Trace-Q_Paper.pdf"
    }
];

export default function Projects() {
    return (
        <div className="projects-container">
            <h1>My Projects</h1>
            <div className="projects-list">
                {projects.map((project, index) => (
                    <div key={index} className="project-card">
                        <h1>{project.type}</h1>
                        <h2>{project.title}</h2>
                        <p>{project.description}</p>

                        <div className="card-footer">
                            <ul>
                                {project.technologies.map((tech, i) => (
                                    <li key={i}>{tech}</li>
                                ))}
                            </ul>
                            {project.github && (
                                <a href={project.github} target="_blank" rel="noopener noreferrer" className="link-button github-link">
                                    <img src={githubIcon} alt="GitHub" className="projects-icon" />
                                    GitHub
                                </a>
                            )}
                            {project.paper && (
                                <a href={project.paper} target="_blank" rel="noopener noreferrer" className="link-button paper-link">
                                    <img src={pdfIcon} alt="PDF" className="projects-icon" />
                                    Paper
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}